var rheinlandPfalzQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Rheinland-Pfalz?',
    image: '401',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Rheinland-Pfalz?',
    answers: [
      {
        content: 'Westerwaldkreis',
        key: 1,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Emsland',
        key: 0,
      },
      {
        content: 'Prignitz',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Rheinland-Pfalz gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Rheinland-Pfalz bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 0,
      },
      {
        content: '18',
        key: 1,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Rheinland-Pfalz?',
    answers: [
      {
        content: 'rot-weiß',
        key: 0,
      },
      {
        content: 'schwarz-rot-gold',
        key: 1,
      },
      {
        content: 'schwarz-gelb',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Rheinland-Pfalz über politische Themen informieren?',
    answers: [
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Rheinland-Pfalz heißt...',
    answers: [
      {
        content: 'Mainz.',
        key: 1,
      },
      {
        content: 'Kaiserslautern.',
        key: 0,
      },
      {
        content: 'Ludwigshafen.',
        key: 0,
      },
      {
        content: 'Koblenz.',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Rheinland-Pfalz?',
    image: '408',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Rheinland-Pfalz?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Rheinland-Pfalz nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Rheinland-Pfalz',
  },
]

export default rheinlandPfalzQuestions
